<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">




    <div class="col-6 mt-3"> 


          <!-- Button trigger modal -->
<button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6 || this.$store.state.user.positionID==10"  type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
 დამატება
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="mb-3 mt-3">

 
<select class="form-select" v-model="programID">
<option value="0">პროგრამა</option>
<option :value="program.programID" v-for="program in programs" :key="program.programID">{{program.program_name}} ({{ program.program_types.program_type }})</option>

</select>

</div>
       
        <div class="mb-3 mt-3">

 
            <select class="form-select" v-model="moduleID">
  <option value="0">მოდული</option>
  <option :value="module.moduleID" v-for="module in modules" :key="module.moduleID">{{module.module_name}}</option>
  
</select>
 
</div>

 
 
<div class="mb-3 mt-3">

 <select class="form-select" v-model="personID">
<option value="0">ლექტორი</option>
<option :value="person.personID" v-for="person in personals" :key="person.personID">{{ person.fname }} {{ person.lname }}</option>
</select> 

</div>

<div class="mb-3">
  <label for="start">დან</label>
    <input class="form-control"  type="date" v-model="start_date"
 />
   

</div>
<div class="mb-3">
  <label for="end"> მდე</label>
    <input  class="form-control" type="date" v-model="finish_date"
  />
    

</div>


<table>
  <thead>
    <tr>
      <th>დღე</th>
      <th>ლექციის დაწყება</th>
      <th>ლექციის დასრულებს</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="day in days" :key="day.dayID">
      <td>
        {{ day.day }}
      </td>
      <td>
        <input type="text" placeholder="მაგ.: 09:00" v-model="lecture_start[day.dayID]" class="form-control"/>
      </td>
      <td>
        <input type="text" placeholder="მაგ.: 13:00" v-model="lecture_end[day.dayID]" class="form-control"/>
      </td>
    </tr>
  </tbody>
</table>
        


      </div>
      <div class="modal-footer">
        
        <button type="button" class="btn btn-success" @click="savegroup()">შენახვა</button>
      </div>
    </div>
  </div>
</div>


<button type="button" class="btn btn-success" id="addTimes" style="display: none;" data-bs-toggle="modal" data-bs-target="#addDayAndTimeleModal">
 დამატება
</button>

<div class="modal fade" id="addDayAndTimeleModal" tabindex="-1" aria-labelledby="addDayAndTimeleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body"> 
<table>
  <thead>
    <tr>
      <th>დღე</th>
      <th>ლექციის დაწყება</th>
      <th>ლექციის დასრულებს</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="day in days" :key="day.dayID">
      <td>
        {{ day.day }}
      </td>
      <td>
        <input type="text" placeholder="მაგ.: 09:00" v-model="lecture_start[day.dayID]" class="form-control"/>
      </td>
      <td>
        <input type="text" placeholder="მაგ.: 13:00" v-model="lecture_end[day.dayID]" class="form-control"/>
      </td>
    </tr>
  </tbody>
</table>
        


      </div>
      <div class="modal-footer">
        
        <button type="button" class="btn btn-success" @click="addmoreDayAndTime(chosenGroupID)">შენახვა</button>
      </div>
    </div>
  </div>
</div>







<div class="modal fade" id="addAnotherStartEnd" tabindex="-1" aria-labelledby="addAnotherStartEndLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
  

<div class="mb-3">
  <label for="start">დან</label>
    <input class="form-control"  type="date" v-model="start_date"
 />
   

</div>
<div class="mb-3">
  <label for="end"> მდე</label>
    <input  class="form-control" type="date" v-model="finish_date"
  />
    

</div>


<table>
  <thead>
    <tr>
      <th>დღე</th>
      <th>ლექციის დაწყება</th>
      <th>ლექციის დასრულებს</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="day in days" :key="day.dayID">
      <td>
        {{ day.day }}
      </td>
      <td>
        <input type="text" placeholder="მაგ.: 09:00" v-model="lecture_start[day.dayID]" class="form-control"/>
      </td>
      <td>
        <input type="text" placeholder="მაგ.: 13:00" v-model="lecture_end[day.dayID]" class="form-control"/>
      </td>
    </tr>
  </tbody>
</table>
        


      </div>
      <div class="modal-footer">
        
        <button type="button" class="btn btn-success" @click="saveAnotherStartEnd()">შენახვა</button>
      </div>
    </div>
  </div>
</div>








<div class="modal fade" id="showDetails" tabindex="-1" aria-labelledby="showDetailsLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
        <table class="table" v-if="detailedGroup.length>0">
   <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col">მოდული</th>
       <th scope="col">ლექტორი</th>
       <th scope="col">დღე</th>
       <th scope="col">ლექციის დაწყება</th>
       <th scope="col">ლექციის დასრულება</th>
       <th scope="col">დან</th>
       <th scope="col">მდე</th>
     
      
 
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="group in detailedGroup" :key="group.groupID" @dblclick="addDayAndTimes(group.groupID)">
       <th scope="row">{{ group.groupN }}</th>
       <td>{{ group.module_name.module_name }}</td>
       <td>{{ group.person?group.person.fname:'' }} {{ group.person?group.person.lname:'' }}</td>
       <td>{{ group.day.day }}</td>
       <td>{{ group.lecture_start }}</td>
       <td>{{ group.lecture_end}}</td>
       <td>{{ group.start_date}}</td>
       <td>{{ group.finish_date}}</td>
       <td><button type="button" data-bs-toggle="modal" data-bs-target="#addstudentsModal" @click="addStudentsToGroup(group.groupN)" class="btn btn-outline-success"><i class='bx bxs-user-account'></i></button> </td>
       <td> <button type="button" data-bs-toggle="modal" data-bs-target="#addAnotherStartEnd" @click="addAnotherStartEnd(group.groupN)" class="btn btn-outline-success"><i class='bx bxs-time-five'></i></button></td>
       <td> <button type="button" @click="deleteGroupRow(group.groupID)" class="btn btn-outline-success"><i class='bx bx-x'></i></button></td>
        
    
     </tr>
    
   
   
 
   </tbody>
 </table>
        


      </div>
   
    </div>
  </div>
</div>



<div class="modal fade" id="updateProgramToGroup" tabindex="-1" aria-labelledby="updateProgramToGroupLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
   

        <select class="form-select" v-model="programID">
<option value="0">პროგრამა</option>
<option :value="program.programID" v-for="program in programs" :key="program.programID">{{program.program_name}} ({{ program.program_types.program_type }})</option>

</select>
        
<button type="button" @click="updateProgramID(groupNToUpdate)" class="btn btn-outline-success d-block mx-auto mt-4">შენახვა</button>

      </div>
   
    </div>
  </div>
</div>

























 

<div class="modal fade" id="addstudentsModal" tabindex="-1" aria-labelledby="addstudentsModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body"> 

        <select class="form-control" v-model="chosenStudentID">
          <option value="0">აირჩიეთ სტუდენტები</option>
          <option v-for="student in students" :value="student.studentID" :key="student.studentID">{{ student.fname }} {{ student.lname }}</option>
        </select>
        
     
        <table class="mt-3 w-100" v-if="chosenStudents.length>0">
          <tr v-for="chosenStudent in chosenStudents" :key="chosenStudent">
             
            <td>{{ students.find(o=>o.studentID==chosenStudent).fname }} {{ students.find(o=>o.studentID==chosenStudent).lname }}</td>
            <td><button type="button" @click="deleteStudentFromGroup(chosenGroupN,chosenStudent)" class="btn btn-outline-success"><i class='bx bx-x'></i></button></td>
          </tr>
        </table>


      </div>
      <div class="modal-footer">
        
        <button type="button" class="btn btn-success" @click="saveStudents(chosenGroupN)">შენახვა</button>
      </div>
    </div>
  </div>
</div>
 
           
         
        </div> 
             <div class="col-12 mt-3">

 
              <table class="table">
   <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col">მოდული</th>
       <th scope="col">ლექტორი</th> 
       <th scope="col">მოდულის დაწყება</th>
       <th scope="col">მოდულის დასრულება</th>
       <th scope="col">პროგრამა</th>
     
      
 
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="group in groups" :key="group.groupN">
     
       <th scope="row">{{ group.groupN }}</th>
       <td>{{ group.module_name.module_name }}</td>
       <td>{{ group.person?group.person.fname:'' }} {{ group.person?group.person.lname:'' }}</td> 
       <td>{{ group.start_date}}</td>
       <td>{{ group.finish_date}}</td>
       <td>{{ group.program?group.program.program_name+' ('+group.program.program_types.program_type+')':''}}</td>
       <td>
        
        <button  v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6" type="button" data-bs-toggle="modal" data-bs-target="#showDetails" @click="showDetails(group.groupN)" class="btn btn-outline-success"><i  class='bx bxs-info-circle'></i></button>
        
        
      </td>
      <td>
         
        
        <div  class="form-check form-switch" v-if="(group.registrations.length>0 && group.registrations.filter(o=>o.evaluations.length>0).length>0) && (this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6)" >
            <input class="form-check-input" type="checkbox" v-model="sheetPrinted[group.groupN]"  @change="updateSheetPrintStatus(group.groupN)">
            <button type="button"   @click="printSheet(group.groupN)" class="btn btn-outline-success"><i class='bx bx-spreadsheet'></i></button>
      </div>
      </td>

      <td>
        
        <button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6" type="button" data-bs-toggle="modal" data-bs-target="#updateProgramToGroup"   @click="updateProgramToGroup(group.groupN)" class="btn btn-outline-success"><i class='bx bxl-product-hunt'></i></button>
        
        
      </td>
    
    
     </tr>
    
   
   
 
   </tbody>
 </table>


 
  
             </div>
 
     </div>
    </div>
  

 </template>

 <script>

//import Multiselect from '@vueform/multiselect'
import HttpRequests from '../httpRequests/httpRequests'
 const httpRequests= new HttpRequests()

  export default {
  
    data() {
      return {
        modules:[],
        days:[],
        personals:[],
        moduleID:0, 
        personID:0,
        start_date:null,
        finish_date:null,
        lecture_start:{},
        lecture_end:{},
        groups:[],
        chosenGroupID:0,
        chosenGroupN:0,
        students:[],
        chosenStudentID:0,
        chosenStudents:[],
        detailedGroup:[],
        programs:[],
        programID:0,
        groupNToUpdate:0,
        sheetPrinted:{}


      }


  },

  watch:{
    chosenStudentID(value){
      
      if(value>0){
 
        this.chosenStudents.push(value)
        
      }
 

    }

  },

  methods:{

    updateSheetPrintStatus(groupN){

     

       
      httpRequests.updateSheetPrintStatus(groupN,this.sheetPrinted[groupN]).then(()=>{

        //location.reload()

      })

    },


    updateProgramID(groupN){


      httpRequests.updateProgramID(groupN,this.programID).then(()=>{
         location.reload()
      })

        


    },

    updateProgramToGroup(groupN){

      this.groupNToUpdate=groupN
    },
    


    printSheet(groupN){

      window.open('https://api.ugcollege.ug.edu.ge/api/printSheet?groupN='+groupN+'&token='+localStorage.getItem('token')+'','_blank')

    },

    showDetails(groupN){

      httpRequests.getGroupsDetailed(groupN).then(response=>{
      this.detailedGroup=response.data
      
    })


    },



    addAnotherStartEnd(groupN){

      this.chosenGroupN=groupN

    },



savegroup(){

   if(this.personID==0 || this.programID==0){

    alert('გამორჩენილია პროგრამა ან ლექტორი!!!')
  

}else {

  httpRequests.savegroup(this.moduleID, this.personID,this.start_date,this.finish_date,this.lecture_start,this.lecture_end,this.programID).then(()=>{
    location.reload()
  })

}

},


saveAnotherStartEnd(){
  httpRequests.saveAnotherStartEnd(this.chosenGroupN,this.start_date,this.finish_date,this.lecture_start,this.lecture_end).then(response=>{
    location.reload()
  })


},

deleteGroupRow(groupID){

  if(confirm('ნამდვილად გსურთ წაშლა?')){
    httpRequests.deleteGroupRow(groupID).then(()=>{
      location.reload()
    })
  }

},

addDayAndTimes(groupID){

  document.getElementById('addTimes').click()

  this.chosenGroupID=groupID

},
addmoreDayAndTime(groupID){
 

  httpRequests.addmoreDayAndTime(groupID,this.lecture_start,this.lecture_end).then(()=>{
    location.reload()
  })

},

getStudentsInGroup(groupN){


this.chosenStudents=[]
  httpRequests.getStudentsInGroup(groupN).then(response=>{
    
    for(let data of response.data){
 

      this.chosenStudents.push(data.studentID)
    }
   
  })

},

addStudentsToGroup(groupN){
  

  this.chosenGroupN=groupN

  this.getStudentsInGroup(groupN)

},
deleteStudentFromGroup(groupN,studentID){

  if(confirm('ნამდვილად გსურთ წაშლა?')){

    this.chosenStudents.splice(this.chosenStudents.findIndex(o=>o==studentID),1)

    httpRequests.deleteStudentFromGroup(groupN,studentID).then(()=>{
      alert("სტუდენტი წაშლილია ჯგუფიდან!")


      this.getStudentsInGroup(groupN)


    })

  }

},
saveStudents(groupN){

    httpRequests.saveStudents(groupN,this.chosenStudents).then(()=>{
      location.reload()
    })

}

  },


  mounted(){
  httpRequests.getModule().then(response=>{
    this.modules=response.data
})

httpRequests.getDays().then(response=>{
  this.days=response.data
})

 

httpRequests.getperson().then(response=>{
  this.personals=response.data
})

httpRequests.getGroups().then(response=>{
  this.groups=response.data


  for(let group of response.data){
    this.sheetPrinted[group.groupN]=group.sheet_printed>0
  }
  
})

httpRequests.getstudent().then(response=>{
  this.students=response.data
})


httpRequests.getPrograms().then(response=>{
  this.programs=response.data
})

},


  }

 



</script>
